import { useQuery } from 'react-query';
import { fetchPosts } from '@/api/community';

export function useGetPosts<Type>({
  query,
  type,
}: {
  query: Type;
  type?: 'notice' | 'free' | 'event' | undefined;
}) {
  const data = useQuery([{ ...query }], () => fetchPosts({ ...query, type }), {
    keepPreviousData: true,
    retry: false,
  });
  return [data];
}
